import { render } from "./PartHistoryList.vue?vue&type=template&id=a88a3bec"
import script from "./PartHistoryList.vue?vue&type=script&lang=js"
export * from "./PartHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__